import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e27966cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_3 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_4 = { class: "sheetMusicCreationMask" }
const _hoisted_5 = { class: "sheetMusicCreationText" }

import useCompileContent from "@/hooks/useCompileContent";
import useExam from "@/hooks/useExam";
import useUpLoadResource from "@/hooks/useUpLoadResource";
import { domStrToImage } from "@/utils/common";
import { unLock } from "@/utils/liner-lock";
import "@evideo/design-vue/lib/draggable/style";
import SheetMusicSimpleCreation from "@evideo/design-vue/lib/sheet-music-simple-creaton";
import "@evideo/design-vue/lib/sheet-music-simple-creaton/style";
import _ from "lodash";
import { computed, onMounted, ref, watch } from "vue";
import ConfirmDialog from "./ConfirmDialog.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
  uploadProctor: {
    type: Boolean,
    default: false,
  },
},
  emits: ["error", "resetSheet"],
  setup(__props, { expose, emit: emits }) {

const props = __props





const { showExamMessageBox, showExamTipBox } = useExam();
const { upload, dataURLtoFile } = useUpLoadResource();
const { compileQuestionTitle } = useCompileContent();

const question = ref(props.question || {});
watch(
  () => props.question,
  (now: any) => {
    question.value = now;
  },
  { deep: true }
);

// * 标题编译
const questionTitle = ref<HTMLDivElement>();
compileQuestionTitle(questionTitle, question.value.title || "");

// * 创编组件相关
const sheetMusicContainerEl = ref<HTMLDivElement>();

const sheetMusicCreationData = computed(() => {
  let data = null;
  try {
    data = {
      song: {
        sheetFileUrl: question.value?.question_params?.sheet_file_url,
        answerFilePath: question.value?.answer_params?.sheet_file_url,
        midiEnable: question.value?.question_params?.midi_enable || false,
      },
      draggableOpt: {
        distanceRight: document.documentElement.clientWidth * 0.31,
        distanceBottom: 130,
        zIndex: 1000,
      },
      loadSheetMode: "common",
      svgApi: `${process.env.VUE_APP_PRE_RENDER_SERVICE}/sheet-svg/render-data`,
    };
  } catch (e) {
    console.warn("曲谱题目加载失败", e);
    showExamMessageBox({
      message: "题目加载失败，请稍后再次尝试",
    });
  }
  if (!data) {
    return {};
  }
  return data;
});

const sheetMusicCreationEl = ref<any>();

const dailogShow = ref(false);
const submitDisabled = ref(false);

const handleCancel = () => {
  dailogShow.value = false;
};
const handleSubmit = _.throttle(() => {
  dailogShow.value = false;
  submitDisabled.value = true;
  setTimeout(async () => {
    await sheetMusicCreationEl.value.resetSheet();
    submitDisabled.value = false;
    // todo: 删除用户所做的答案
    question.value.answer_params = undefined;
    question.value.answerScore = 0;

    originAnswer.value = await getAnswer(true);
    emits("resetSheet", question.value);
  }, 500);
}, 1000);

const onRestConfirm = () => {
  dailogShow.value = true;
};
const loading = ref(true);
let closeLoading: any = undefined;
let musicCreationLoading = ref(false);
const musicCreationLoadingTip = ref("编创题目加载中...");

const handleLoading = (status: boolean, tip: string) => {
  if (status) {
    loading.value = true;
    if (!closeLoading) {
      // 曲谱加载中，创建实例
      musicCreationLoading.value = true;
      console.log("handleLoading", tip);
      if (tip) {
        musicCreationLoadingTip.value = tip;
      } else {
        musicCreationLoadingTip.value = "编创题目加载中...";
      }
      // closeLoading = showLoading("曲谱题目加载中...");
    }
  } else {
    loading.value = false;
    musicCreationLoading.value = false;
    if (closeLoading) {
      // 曲谱加载完毕，关闭实例
      closeLoading();
    }
  }
};

const handleError = (e: any) => {
  // emits("error", e);
  const msg = typeof e === "string" ? e : e.message;
  showExamTipBox(msg);
};
const originAnswer = ref<any>();

const onSheetLoadedSuccess = async () => {
  originAnswer.value = await getAnswer(true);
};

const getAnswer = async (preUpload = false) => {
  if (props.disabled) {
    // 禁用了不用获取答案
    return { type: 0 };
  }
  await sheetMusicCreationEl.value.stopPlay();
  const { xml, svg } = sheetMusicCreationEl.value.getSheet();
  const paperId = question.value.paper_id;
  const savePath = `${paperId}/${question.value!.id}`;

  const sheetName = `${paperId}_${question.value!.id}.evxml`;
  const sheetBlob = new Blob([xml], { type: "text/xml" });
  const sheetFile = new File([sheetBlob], sheetName, {
    type: "text/xml",
    lastModified: Date.now(),
  });
  const getSheetResult = async (preUpload: boolean) => {
    return await upload(
      sheetFile,
      savePath,
      {
        cache: true,
        override: true,
        preUpload,
      },
      props.uploadProctor
    );
  };
  let sheetReuslt = await getSheetResult(true);

  const imageName = `${paperId}_${question.value!.id}.png`;
  const imageUrl = await domStrToImage(svg);
  const imageFile = dataURLtoFile(imageUrl, imageName);
  const getImageResult = async (preUpload: boolean) => {
    return await upload(
      imageFile,
      savePath,
      {
        cache: true,
        override: true,
        preUpload,
      },
      props.uploadProctor
    );
  };
  let imageResulit = await getImageResult(true);
  const getParams = () => {
    return {
      sheet_file_md5: sheetReuslt.md5,
      sheet_file_url: sheetReuslt.url,
      sheet_image_url: imageResulit.url,
      sheet_image_md5: imageResulit.md5,
    };
  };
  let params = getParams();
  if (preUpload) {
    return params;
  }
  if (!question.value.answer_params) {
    //* 没有回答过答案
    if (originAnswer?.value?.sheet_image_md5 === params?.sheet_image_md5) {
      //* 图片md5一样 代表没有碰过答案
      return { type: 0 };
    } else {
      sheetReuslt = await getSheetResult(false);
      imageResulit = await getImageResult(false);
      params = getParams();
      return {
        type: 1,
        answer_params: {
          ...params,
          origin_sheet_image_md5: originAnswer.value.sheet_image_md5,
          origin_sheet_file_md5: originAnswer.value.sheet_file_md5,
        },
      };
    }
  } else {
    //* 回答过答案
    const { origin_sheet_image_md5 } = question.value.answer_params;
    if (origin_sheet_image_md5 === params.sheet_image_md5) {
      //* 图片md5一样 代表又被修改成原始答案了
      return { type: 1, answer_params: undefined };
    } else {
      sheetReuslt = await getSheetResult(false);
      imageResulit = await getImageResult(false);
      params = getParams();
      return {
        type: 1,
        answer_params: _.merge(question.value.answer_params, params),
      };
    }
  }
};

watch(
  () => loading.value,
  () => {
    if (props.disabled) {
      showResult();
    }
  }
);

watch(
  () => props.disabled,
  () => {
    if (props.disabled) {
      showResult();
    }
  }
);

const showResult = () => {
  const resultScore = document.createElement("div");
  resultScore.style.fontSize = "30px";
  resultScore.style.display = "flex";
  resultScore.style.justifyContent = "flex-start";
  resultScore.style.color = "#495561";
  resultScore.style.marginTop = "60px";
  resultScore.style.height = "20px";
  resultScore.innerHTML =
    "<div style='width:160px;margin-left: 10px;text-align:left;'>作答结果:</div>" +
    "<div style='width: calc(100% - 160px);text-align:left;'>" +
    (question.value?.answerScore || 0) +
    "分</div>";
  sheetMusicContainerEl.value &&
    sheetMusicContainerEl.value.appendChild(resultScore);

  const resultAnalysis = document.createElement("div");
  const resultAnalysisContent = document.createElement("div");
  resultAnalysis.style.fontSize = "30px";
  resultAnalysis.style.display = "flex";
  resultAnalysis.style.justifyContent = "flex-start";
  resultAnalysis.style.color = "#495561";
  resultAnalysis.style.marginTop = "60px";

  resultAnalysis.innerHTML =
    "<div style='width:120px;margin-left:10px;text-align:left;margin-bottom:60px;'>解析:</div>";
  resultAnalysisContent.style.width = "calc(100% - 120px)";
  resultAnalysisContent.style.textAlign = "left";
  resultAnalysisContent.innerHTML = question.value?.analysis || "";

  resultAnalysis.appendChild(resultAnalysisContent);

  sheetMusicContainerEl.value &&
    sheetMusicContainerEl.value.appendChild(resultAnalysis);
};

expose({ getAnswer });

onMounted(() => {
  console.log("参数", props.question);
  unLock();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "dv-question-title",
      ref_key: "sheetMusicContainerEl",
      ref: sheetMusicContainerEl
    }, [
      _createElementVNode("div", _hoisted_1, [
        (props.showQuestionNum)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(question.value.indexInQuestion !== undefined
            ? question.value.indexInQuestion + "."
            : "") + _toDisplayString(question.value.titleNum > 0 ? question.value.titleNum : ""), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "dvCompile",
          class: "dv-title",
          ref_key: "questionTitle",
          ref: questionTitle
        }, null, 512),
        (props.showQuestionScore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " (" + _toDisplayString(question.value.score) + "分) ", 1))
          : _createCommentVNode("", true),
        _createVNode(_unref(SheetMusicSimpleCreation), _mergeProps({
          ref_key: "sheetMusicCreationEl",
          ref: sheetMusicCreationEl,
          disabled: props.disabled,
          "sheet-music-creation-el": sheetMusicContainerEl.value
        }, _unref(sheetMusicCreationData), {
          onRestConfirm: onRestConfirm,
          onLoading: handleLoading,
          onSuccess: onSheetLoadedSuccess,
          onError: handleError
        }), null, 16, ["disabled", "sheet-music-creation-el"]),
        _createVNode(ConfirmDialog, {
          header: "重置曲谱",
          content: "重置会覆盖已作答的内容，恢复成考题曲谱",
          visible: dailogShow.value,
          submitDisabled: submitDisabled.value,
          onCancel: handleCancel,
          onSubmit: _unref(handleSubmit)
        }, null, 8, ["visible", "submitDisabled", "onSubmit"])
      ])
    ], 512),
    (_unref(musicCreationLoading) == true)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(musicCreationLoadingTip.value), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})